import setViewRecords from './helpers/setViewRecords';

export default {
  // Гант грузит записи двумя выборками (до и после сегодня) и кладёт уже объединённый
  // результат, поэтому обычный путь через offset тут не подходит: обе выборки начинаются
  // с нуля и перетёрли бы друг друга.
  setGanttRecords(sceneId, records) {
    if (!this.getIn(['scenes', sceneId])) return;

    setViewRecords(this, sceneId, 'ganttRecords', records);
  },
};
